export const HOME = {
	path: '/',
	exact: true,
};

export const CALLBACK = {
	path: '/callback',
};

export const TEAM_HOME = {
	path: '/team/:teamId',
};

export const SIGN_OUT = {
	path: '/signout',
};

export const TEAM = {
	path: '/team',
};
